import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import CheckBox from "components/CheckBox";
import clsx from "clsx";

import styles from "./index.module.css";
const Step2 = () => {
    const history = useHistory();
    const [checkboxValue, setCheckboxValue] = useState(false);

    return (
        <div className={styles.step2Page}>
            <Paper className={styles.paper}>
                <Text className="mt-0" type={"h1"}>
                    Confidențialitatea datelor:
                </Text>
                <Text className="mt-0" type={"h3"}>
                    Acest serviciu este oferit de Direcția de Asistență Integrată a
                    Sectorului 4, care procesează și folosește datele dumneavoastră
                    personale (Nume, CNP, Număr de telefon, Adresă email), cu respectarea
                    drepturilor prevăzute de Regulamentul (UE) 2016/679. Datele
                    dumneavoastră sunt necesare pentru programare, confirmare, acces, și
                    procesele interne necesare pentru serviciul cerut de dumneavoastră.
                </Text>
                <Text className="mt-0" type={"h3"}>
                    Aveți dreptul să nu vă dați acordul, caz în care accesul dumneavoastră
                    la acest serviciu va fi limitat.
                </Text>
                <div className="mb-26">
                    <CheckBox
                        label="Obligatoriu: Sunt de acord cu procesarea datelor mele personale"
                        checked={checkboxValue}
                        onClick={(e) => setCheckboxValue(e.target.checked)}
                    />
                </div>
                <div
                    className={clsx(
                        styles.actionContainer,
                        styles.alignCenter,
                        styles.spaceBtw
                    )}
                >
                    <Button
                        className={styles.prevButton}
                        size="large"
                        variant="secondary"
                        label="<- înapoi"
                        onClick={() => history.push("/programare/step1")}
                    />
                    <Button
                        className={styles.nextButton}
                        size="large"
                        label="Continuă ->"
                        disabled={!checkboxValue}
                        onClick={() => history.push("/programare/step3")}
                    />
                </div>
            </Paper>
        </div>
    );
};

export default Step2;
